/**
 * Router hook register-navigation-guard.js
 *
 * @namespace register-navigation-guard
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/router/hooks/register-navigation-guard.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 */

import app from "../../app";
import * as queries from "../../store/user/queries";
import store from 'dashboard/store';

/**
 * Only navigation to these screens will be logged.
 * @type {string[]}
 */
const screenNavigationsToLog = [
    "DSSCardioMedication",
    "DSSOtherMedication"
]

/**
 * Logs when user is going to certain screens to the PPP backend
 * @function
 * @memberof register-navigation-guard
 */
export default (to, from, next) => {
  // Specific to DSS: Register navigation only on initial load
  const DSSFirstLoad = store.getters['dss/DSSFirstLoad']
  const screens = [...DSSFirstLoad.screens, to.name]

  const navigationLogShouldBeSkipped = DSSFirstLoad.screens.includes(to.name);

  if (screenNavigationsToLog.includes(to.name) && !navigationLogShouldBeSkipped) {
    try {
      const {errors} = app.apolloMobileClient.mutate({
        mutation: queries.registerNavigation,
        variables: {
          targetScreen: to.name,
          sourceScreen: from.name || '',
          targetPatientId: parseInt(store.getters['patientSummary/id'])
        },
      });

      if (!errors) {
        store.dispatch('dss/setDSSFirstLoad', {...DSSFirstLoad, screens});
      }

      if (errors && errors.length) {
        errors.forEach((error) => {
          store.dispatch('error/submit', error, {root: true});
        });
      }
    } catch (error) {
      store.dispatch('error/submit', error, {root: true});
    }
  } else if (!screenNavigationsToLog.includes(to.name) && !to.path.includes('/dss/')) {
    // After leaving DSS (any other screen) - reset
    store.dispatch('dss/resetDSSLastAuditTrails');
  }

  next();
}
